<template>
  <table 
    :class="classTable"
    v-aw-driver-element="'ComponentTable'"
  >
    <thead>
      <slot name="header" v-bind="headerSlot"></slot>
    </thead>
    <tbody v-if="data.rows.length">
      <template v-for="(row, rowIndex) in data.rows" :key="row">
        <slot
          name="row"
          v-bind="{ sortList, filterList, row, rowMouseDown, rowMouseUp, rowIndex }"
        />
        <tr v-if="row._subrow && row._subrow.canopen && row._subrow.opened">
          <td :colspan="Object.keys(headerSlot.headers).length + 1" class="Table__Wrapper relative p-0 pl-6 !bg-gray-200">
            <div class="Table__SubRow-VisualLine absolute w-px inset-0 bg-gray-400"/>
            <slot v-if="$slots['subrow'+ row['_id']]"
              :name="'subrow'+ row['_id']"
            />
            <component v-else :is="$snippets['snippet-' + controlName + '-subrow'+ row['_id']]" />
          </td>
        </tr>
      </template>
    </tbody>
    <tbody v-else>
      <tr>
        <td :colspan="Object.keys(headerSlot.headers).length + 1">
          <form-alert alert="info">{{ $t('No records found') }}</form-alert>
          <!-- <div
            class="flex flex-col h-full items-center justify-items-center px-6 py-6"
          >
            <div class="text-gray-500">
              <aw-icon
                icon="inbox"
                class="mb-4"
                style="width: 64px; height: 64px;"
              ></aw-icon>
            </div>
            <form-alert alert="info">Žádné záznamy nenalezeny</form-alert>
            <p class="text-gray-600">
              Vytvořte nový záznam nebo upravte nastavené filtry.
            </p>
            <div class="mt-5" v-if="addBtnData">
              <a :href="addBtnData.link" class="btn btn-primary">
                <aw-icon icon="plus" class="mr-2"></aw-icon>
                {{ addBtnData.text }}
              </a>
            </div>
          </div> -->
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
//import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'bc-table',
  props: {
    data: {
      required: true,
      type: Object
    },
    sortList: {
      required: false,
      type: Object,
      default() {
        return {}
      }
    },
    filterList: {
      required: false,
      type: Object,
      default() {
        return {}
      }
    },
    controlName: {
      required: true,
      type: String
    },
    addBtnData: {
      required: false,
      type: Object
    },
    rowClickAction: {
      required: false,
      type: String
    },
    lastEdit: {
      required: false
    },
    classTable: {
      type: [String, Object, Array],
      default:
        'Table Table--Sticky__NA Table--Stripped bg-white rounded-md shadow mb-0'
    }
  },
  data() {
    return {
      headerSlot: {
        sortList: this.sortList,
        filterList: this.filterList,
        headers: this.data.headers,
        openedFilter: null
      },
      rowClickCounter: 0,
      rowClickTimeOut: null,
    }
  },
  components: {},
  computed: {
    hasSidebar() {
      return (
        this.showSidebar &&
        (Object.keys(this.sortList).length > 0 ||
          Object.keys(this.filterList).length > 0)
      )
    }
  },
  methods: {
    editFilter(colName, editUrl) {
      if (
        !this.$snippets['snippet-' + this.controlName + '-filter' + colName]
      ) {
        NetteAjax.ajax({
          url: editUrl,
          spinners: [colName + '-filter']
        })
      }
      this.headerSlot.openedFilter = colName
    },
    rowMouseDown ($event) {
      this.rowClickCounter = $event.detail
      if (this.rowClickTimeOut) {
        return
      }

      this.rowClickTimeOut = setTimeout(() => {
        this.rowClickTimeOut = null
      }, 250)
    },
    rowMouseUp ($event, row) {
      let { target } = $event
      while (target && target.tagName !== 'A') target = target.parentNode

      if (target) return

      $event.stopPropagation()
      $event.preventDefault()

      if (this.rowClickAction && row._rowActions[this.rowClickAction] && this.rowClickTimeOut) {
        setTimeout(() => {
          if (this.rowClickCounter === 1) {
            NetteAjax.ajax(row._rowActions[this.rowClickAction])
          }
        }, 140)
      }
    }
  },
  mounted() {
    // for multiple shift select
    const enableSubRowSelect = this.$route.path.includes('notification.shared')
    
    if (this.data.rows.length > 0) {
      for (let index = 0; index < this.data.rows.length; index++) {
        let subRowElements

        const rowElement = this.$el.querySelector('[data-item-index="' + index + '"]')
        
        if (!rowElement) {
          break
        }

        if (enableSubRowSelect) {
          subRowElements = this.$el.querySelectorAll('[data-item-index="' + index + '"]')
        }

        if (!enableSubRowSelect) {
          rowElement.item = this.data.rows[index]
        } else {
          subRowElements.forEach((subRowElement, subRowIndex) => {
            subRowElement.item = this.data.rows[index].bc_share_user[subRowIndex]
          })
        }
      }
    }
  },
  watch: {
    sortList(newVal) {
      this.headerSlot.sortList = newVal
    },
    filterList(newVal) {
      this.headerSlot.filterList = newVal
    },
    data(newVal) {
      this.headerSlot.headers = newVal.headers
    }
  }
}
</script>

<style lang="scss" scoped>
.TableOverflowSolver .Table {
  .Table {
    @apply rounded-none shadow-none;
  }
}

@media (max-width: 600px) {
  .Table--Sticky {
    @apply static;
  }
  .Table {
    tr:first-child {
      @apply hidden;
    }
  }
}
</style>
